import React from 'react';
import PropTypes from 'prop-types';

const LShapeEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
}) => {
  // const verticalFirst = Math.abs(targetY - sourceY) > Math.abs(targetX - sourceX);

  // const path = verticalFirst
  //   ? `M ${sourceX},${sourceY} L ${sourceX},${targetY} L ${targetX},${targetY}`
  //   : `M ${sourceX},${sourceY} L ${targetX},${sourceY} L ${targetX},${targetY}`;
  
  const dy = targetY - sourceY;
  const verticalFirst = dy < 0; 

  const path = verticalFirst
    ? `M ${sourceX},${sourceY} L ${sourceX},${targetY} L ${targetX},${targetY}` 
    : `M ${sourceX},${sourceY} L ${targetX},${sourceY} L ${targetX},${targetY}`;

  return (
    <path
      id={id}
      d={path}
      fill="none"
      stroke="#1976d2"
      strokeWidth={1.5}
      markerEnd={markerEnd}
    />
  );
};

LShapeEdge.propTypes = {
  id: PropTypes.string.isRequired,
  sourceX: PropTypes.number.isRequired,
  sourceY: PropTypes.number.isRequired,
  targetX: PropTypes.number.isRequired,
  targetY: PropTypes.number.isRequired,
  markerEnd: PropTypes.any,
};

export default LShapeEdge;
